/**
 * noneMessaging — MessagingPort adapter that reports no channels.
 *
 * Used when no channel is wired. Real adapters (whatsapp, sms, email)
 * implement the same port.
 */
export function createNoneMessaging() {
  return {
    async availableChannels() { return []; },
    async channelStatus() { return { status: "not_connected" }; },
    async send() {
      return { ok: false, error: "MESSAGING_NOT_CONFIGURED" };
    },
  };
}
